import { AlchemerApi } from "./AlchemerApi";

export interface Configuration {
  provider: "alchemer" | null;
  projectId: string;
}

export interface AnyProvider {
  hideNativeControls: () => void;
  showNativeControls: () => void;
  clickNextButton: () => void;
  saveResponse: (gameId: string, responseId: string) => void;
}

export class IntegrationApi {
  configuration: Configuration;
  provider: AnyProvider;

  static create(configuration?: Configuration) {
    if (!configuration || !configuration.provider) {
      return new this(
        {
          // eslint-disable-next-line
          hideNativeControls: () => {},
          // eslint-disable-next-line
          showNativeControls: () => {},
          // eslint-disable-next-line
          saveResponse: () => {},
          // eslint-disable-next-line
          clickNextButton: () => {},
        },
        { provider: null, projectId: "" },
      );
    }

    const providers = {
      alchemer: AlchemerApi,
    } as const;

    return new this(new providers[configuration.provider](), configuration);
  }

  constructor(provider: AnyProvider, configuration: Configuration) {
    this.configuration = configuration;
    this.provider = provider;
  }

  get isEmbeeded() {
    return !!this.configuration?.projectId;
  }

  get projectId() {
    return this.configuration?.projectId || "";
  }

  hideNativeControls() {
    if (!this.isEmbeeded) return;
    this.provider.hideNativeControls();
  }

  showNativeControls() {
    if (!this.isEmbeeded) return;
    this.provider.showNativeControls();
  }

  clickNextButton() {
    if (!this.isEmbeeded) return;
    this.provider.clickNextButton();
  }

  saveResponse(gameId: string, responseId: string) {
    if (!this.isEmbeeded) return;
    this.provider.saveResponse(gameId, responseId);
  }
}
